// src/shared/api/axiosInstance.js
import axios from "axios";

export const axiosBaseURL = `https://${process.env.REACT_APP_APP_URL || "app.tablecrm.com"}/api/v1`;

export const axiosInstance = axios.create({
  baseURL: axiosBaseURL,
  headers: { "Content-Type": "application/json" },
});

// Добавляем интерцептор для автоматической подстановки токена
// Примечание: токен добавляется через params в APIRequests классе
axiosInstance.interceptors.request.use(
  (config) => {
    // Токен уже добавляется через params в APIRequests классе
    // Не нужно добавлять его в заголовки, так как API использует token в query params
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(null, (err) => {
  // Обработка Network Error - предотвращаем краш приложения
  if (
    err.code === "ERR_NETWORK" ||
    err.message === "Network Error" ||
    !err.response
  ) {
    // Логируем ошибку, но не крашим приложение
    console.error(
      "Network Error:",
      err.message || "Не удалось подключиться к серверу",
    );
    // Возвращаем ошибку с понятным сообщением
    const networkError = new Error(
      "Не удалось подключиться к серверу. Проверьте подключение к интернету.",
    );
    networkError.isNetworkError = true;
    networkError.originalError = err;
    return Promise.reject(networkError);
  }
  // Для ошибок с response возвращаем исходную ошибку, чтобы сохранить response
  // getStrapiError используется только для форматирования сообщения, но не заменяет ошибку
  return Promise.reject(err);
});

// Функция для получения токена (реализуйте в соответствии с вашей логикой)
// eslint-disable-next-line no-unused-vars
function getTokenFromSomewhere() {
  // Например, из контекста, localStorage, или другого места
  return localStorage.getItem("auth_token") || "";
}
